export default __webpack_public_path__ + "static/media/pic2.d73d54bc.jpg";